<template>
  <div class="invoice-dense-tab">
    <div class="invoice-dense-table-wrap">
      <b-table
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        hover
        responsive
        small
        :busy="loading"
        show-empty
        class="invoice-dense-table mb-0"
      >
        <template #table-busy>
          <div class="invoice-dense-state invoice-dense-state--loading">
            <b-spinner small class="mr-50" />
            <span>Loading audit trail…</span>
          </div>
        </template>
        <template #empty>
          <div class="invoice-dense-state">
            <div class="invoice-dense-empty-icon">
              <feather-icon icon="ActivityIcon" size="28" />
            </div>
            <h6 class="mb-25">No audit trail</h6>
            <p class="text-muted mb-1">
              {{ searchActive
                ? 'Try a different search or clear it.'
                : 'No create/update history for invoices in this period. Dedicated audit API may be unavailable.' }}
            </p>
            <b-button v-if="searchActive" size="sm" variant="outline-secondary" @click="$emit('clear-search')">
              Clear search
            </b-button>
          </div>
        </template>
        <template #cell(timestamp)="{ item }">
          {{ formatDateTime(item.timestamp) }}
        </template>
      </b-table>
    </div>
    <div v-if="totalRows > perPage" class="invoice-dense-pagination">
      <b-pagination
        :value="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        size="sm"
        @change="$emit('page-change', $event)"
      />
    </div>
  </div>
</template>

<script>
import { BTable, BSpinner, BPagination, BButton } from 'bootstrap-vue'
import invoiceFormatMixin from '@/mixins/invoiceFormatMixin'

export default {
  name: 'ReconAuditTrailTab',
  components: { BTable, BSpinner, BPagination, BButton },
  mixins: [invoiceFormatMixin],
  props: {
    items: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    perPage: { type: Number, default: 10 },
    currentPage: { type: Number, default: 1 },
    totalRows: { type: Number, default: 0 },
    searchActive: { type: Boolean, default: false }
  },
  emits: ['page-change', 'clear-search']
}
</script>

<style lang="scss">
@import '../tabs/invoice-dense-tab.scss';
</style>
